import { BlogSection } from '@/types/blog';

export const howItWorksSection: BlogSection = {
  id: 'wie-funktioniert-ki',
  title: 'Wie funktioniert KI-gestützte Webentwicklung?',
  content: `
    <p>
      <a href="https://lovable.dev" target="_blank" rel="noopener noreferrer" class="text-primary hover:underline">Lovable.dev</a> 
      ist eine Plattform, die fortschrittliche KI mit modernen Webtechnologien verbindet.
      Der Entwicklungsprozess gestaltet sich dabei grundlegend anders als bei herkömmlichen Methoden:
    </p>
    
    <ul class="my-4 space-y-2">
      <li class="flex items-start">
        <span class="text-primary mr-2">✓</span>
        <span>Statt komplexe Templates zu konfigurieren, führe ich einfach Gespräche mit der KI</span>
      </li>
      <li class="flex items-start">
        <span class="text-primary mr-2">✓</span>
        <span>Ich beschreibe meine Wünsche in natürlicher Sprache und sehe sofort die Umsetzung</span>
      </li>
      <li class="flex items-start">
        <span class="text-primary mr-2">✓</span>
        <span>Die KI schreibt den Code, während ich mich auf Inhalt und Gestaltung konzentrieren kann</span>
      </li>
      <li class="flex items-start">
        <span class="text-primary mr-2">✓</span>
        <span>Änderungen und Anpassungen können in Echtzeit besprochen und umgesetzt werden</span>
      </li>
    </ul>
    
    <h3>Konkrete Beispiele aus der Praxis</h3>
    
    <p>
      Ein typischer Dialog mit der KI könnte so aussehen:
    </p>
    
    <div class="bg-joerg-50 p-4 rounded-lg border-l-4 border-primary my-6">
      <p class="font-medium mb-2">Meine Anfrage:</p>
      <p class="italic">"Erstelle mir eine moderne Hero-Sektion mit einem Gradient-Hintergrund, einem aussagekräftigen Titel und einem Call-to-Action Button."</p>
      
      <p class="font-medium mt-4 mb-2">KI-Antwort:</p>
      <p class="italic">"Ich erstelle eine Hero-Sektion mit einem eleganten Farbverlauf, professioneller Typografie und einem ansprechenden Button. Die Sektion ist vollständig responsiv und folgt modernen Design-Prinzipien."</p>
    </div>
    
    <p>
      Binnen Sekunden entstand eine professionelle Hero-Sektion, die ich dann durch weitere Dialoge verfeinern konnte: 
      "Mache den Gradient dezenter" oder "Füge ein animiertes Element hinzu". Dieser iterative Prozess ermöglicht es, 
      in kürzester Zeit von einer vagen Idee zu einer professionellen Webseite zu gelangen.
    </p>
    
    <p>
      Die Entwicklung ging erstaunlich schnell voran, da ich mit grundlegenden HTML-Strukturen und Begriffen wie Ankern 
      bereits vertraut war. Meine technische Affinität – insbesondere meine Erfahrung mit Blockchain-Technologie und 
      Machine Learning – hat den Prozess sicherlich erleichtert, aber Lovable.dev ist auch für 
      Menschen ohne Programmierkenntnisse zugänglich gestaltet.
    </p>
  `
};
